import { useMemo } from 'react';
import { Typography } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { ReportItemProps } from './ReportProps';

const ReportItem = ({
  report,
  user,
  hasNonSystemClient,
  lastItem,
  onSelectReport,
}: ReportItemProps) => {
  const canShowReport = useMemo(() => {
    let result = true;
    if (report.roles && report.roles.length > 0) {
      result = report.roles.indexOf(user.role || 'NO_ROLE') > -1;
    }
    return result && hasNonSystemClient;
  }, [report.roles, user.role, hasNonSystemClient]);
  return (
    <>
      {canShowReport && (
        <ListItem
          alignItems="flex-start"
          onClick={() => onSelectReport(report.reportId)}
        >
          <ListItemAvatar>
            <Avatar>{report.icon}</Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={report.name}
            secondary={
              <>
                {report.sub && (
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ display: 'inline' }}
                    color="textPrimary"
                  >
                    {report.sub}
                  </Typography>
                )}
                {report.description}
              </>
            }
          />
        </ListItem>
      )}
      {canShowReport && !lastItem && <Divider variant="inset" component="li" />}
    </>
  );
};

export default ReportItem;
